// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__Itm0n","item":"style__item__VAKIE","color":"style__color__mTOo9"};